var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("app-container", { attrs: { step: 1, "show-mobile-logo": "" } }, [
    _c(
      "div",
      [
        _vm.waitForActivation
          ? _c(
              "app-section",
              [
                _c(
                  "div",
                  { staticClass: "complete-icon waiting" },
                  [_c("w-fa", { attrs: { icon: ["far", "paper-plane"] } })],
                  1
                ),
                _c("h1", [_vm._v(_vm._s(_vm.$ct("email-send")))]),
                _c("p", { staticClass: "sub-welcome" }, [
                  _vm._v(" " + _vm._s(_vm.$ct("email-send-sub")) + " "),
                ]),
                _c("w-button", { staticClass: "mt", attrs: { to: "/" } }, [
                  _vm._v(" " + _vm._s(_vm.$ct("now-login")) + " "),
                ]),
              ],
              1
            )
          : _vm.isCreatingAccount
          ? [
              _c(
                "app-section",
                [
                  _c("app-title", [
                    _vm._v(_vm._s(_vm.$ct("we-re-preparing-your-account"))),
                  ]),
                  _c("app-text", [
                    _vm._v(_vm._s(_vm.$ct("this-can-take-a-few-minutes"))),
                  ]),
                ],
                1
              ),
              _c(
                "app-section",
                [_c("w-progress-circular", { attrs: { large: "" } })],
                1
              ),
            ]
          : [
              _c(
                "app-section",
                [
                  _c("app-title", [_vm._v(_vm._s(_vm.$ct("welcome")))]),
                  _c(
                    "app-text",
                    { attrs: { gray: "" } },
                    [
                      _vm._v(" " + _vm._s(_vm.$ct("sub-welcome")) + " "),
                      _c("w-link", { attrs: { to: "/" } }, [
                        _vm._v(" " + _vm._s(_vm.$ct("link-welcome")) + " "),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("app-section", { staticClass: "error-section no-margin" }, [
                _c(
                  "p",
                  {
                    staticClass: "login-error",
                    class: { visible: !_vm.shownError },
                  },
                  [
                    _c("w-fa", {
                      staticClass: "mrs",
                      attrs: { icon: "exclamation-triangle" },
                    }),
                    _vm._v(_vm._s(_vm.shownError) + " "),
                  ],
                  1
                ),
              ]),
              _c(
                "app-section",
                { style: { paddingTop: 0 } },
                [
                  _c(
                    "w-row",
                    {
                      attrs: { "no-margin": "", "no-padding": "", stretch: "" },
                    },
                    [
                      _c(
                        "w-col",
                        { staticClass: "mt", attrs: { xs: "12", sm: "6" } },
                        [
                          _c("w-input", {
                            class: {
                              error:
                                _vm.usedInputs.firstname &&
                                !_vm.input.firstname,
                            },
                            attrs: {
                              fancy: "",
                              label: _vm.$ct("labels.firstname"),
                              disabled: _vm.disableFormElement,
                            },
                            on: {
                              blur: function ($event) {
                                _vm.usedInputs.firstname = true
                              },
                            },
                            model: {
                              value: _vm.input.firstname,
                              callback: function ($$v) {
                                _vm.$set(_vm.input, "firstname", $$v)
                              },
                              expression: "input.firstname",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { staticClass: "mt", attrs: { xs: "12", sm: "6" } },
                        [
                          _c("w-input", {
                            class: {
                              error:
                                _vm.usedInputs.lastname && !_vm.input.lastname,
                            },
                            attrs: {
                              fancy: "",
                              label: _vm.$ct("labels.lastname"),
                              disabled: _vm.disableFormElement,
                            },
                            on: {
                              blur: function ($event) {
                                _vm.usedInputs.lastname = true
                              },
                            },
                            model: {
                              value: _vm.input.lastname,
                              callback: function ($$v) {
                                _vm.$set(_vm.input, "lastname", $$v)
                              },
                              expression: "input.lastname",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("w-input", {
                    staticClass: "mt",
                    class: {
                      error:
                        _vm.usedInputs.companyname && !_vm.input.companyname,
                    },
                    attrs: {
                      fancy: "",
                      label: _vm.$ct("labels.companyname"),
                      disabled: _vm.disableFormElement,
                    },
                    on: {
                      blur: function ($event) {
                        _vm.usedInputs.companyname = true
                      },
                    },
                    model: {
                      value: _vm.input.companyname,
                      callback: function ($$v) {
                        _vm.$set(_vm.input, "companyname", $$v)
                      },
                      expression: "input.companyname",
                    },
                  }),
                  _c("w-input", {
                    staticClass: "mt",
                    class: { error: _vm.hasError.email },
                    attrs: {
                      name: "username",
                      fancy: "",
                      label: _vm.$ct("labels.email"),
                      required: "",
                      disabled: _vm.disableFormElement,
                    },
                    on: {
                      blur: function ($event) {
                        _vm.usedInputs.email = true
                      },
                    },
                    model: {
                      value: _vm.input.email,
                      callback: function ($$v) {
                        _vm.$set(_vm.input, "email", $$v)
                      },
                      expression: "input.email",
                    },
                  }),
                  _c("w-input", {
                    staticClass: "mt",
                    class: { error: _vm.hasError.phone },
                    attrs: {
                      name: "phone",
                      fancy: "",
                      label: _vm.$ct("labels.phone"),
                      disabled: _vm.disableFormElement,
                    },
                    on: {
                      blur: function ($event) {
                        _vm.usedInputs.phone = true
                      },
                    },
                    model: {
                      value: _vm.input.phone,
                      callback: function ($$v) {
                        _vm.$set(_vm.input, "phone", $$v)
                      },
                      expression: "input.phone",
                    },
                  }),
                  _c("w-select", {
                    staticClass: "mt",
                    attrs: {
                      fancy: "",
                      label: _vm.$ct("labels.lang"),
                      items: _vm.langItems,
                      disabled: _vm.disableFormElement,
                    },
                    model: {
                      value: _vm.input.lang,
                      callback: function ($$v) {
                        _vm.$set(_vm.input, "lang", $$v)
                      },
                      expression: "input.lang",
                    },
                  }),
                  _c("w-input", {
                    staticClass: "mt",
                    class: { error: _vm.hasError.password },
                    attrs: {
                      password: "",
                      fancy: "",
                      label: _vm.$ct("labels.password"),
                      required: "",
                      autocomplete: "new-password",
                      disabled: _vm.disableFormElement,
                    },
                    on: {
                      blur: function ($event) {
                        _vm.usedInputs.password = true
                      },
                    },
                    model: {
                      value: _vm.input.password,
                      callback: function ($$v) {
                        _vm.$set(_vm.input, "password", $$v)
                      },
                      expression: "input.password",
                    },
                  }),
                ],
                1
              ),
              _c(
                "app-section",
                [
                  _c(
                    "app-button",
                    {
                      style: { width: "100%" },
                      attrs: {
                        disabled: _vm.disableFormElement || !_vm.isValid,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.submit()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$ct("submit")) + " ")]
                  ),
                  _c("div", {
                    directives: [
                      {
                        name: "safe-html",
                        rawName: "v-safe-html",
                        value: _vm.$ct("accept"),
                        expression: "$ct('accept')",
                      },
                    ],
                    staticClass: "accept",
                  }),
                ],
                1
              ),
            ],
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }